import { createSelector } from 'reselect'

const getMicrositeState = (state: $TSFixMe) => state.get('microsite')

export const getIsMicrositeBannerDismissed = createSelector(getMicrositeState, (microsite) =>
  microsite?.get('isMicrositeBannerDismissed', false),
)
